import { PolicyConfiguration, PolicyLimitConfiguration, POLICY_TYPE, POLICY_LIMIT_TYPE } from "./policy-configuration";

export class MinSpendPolicy extends PolicyConfiguration {
  constructor(identifier, policyLevel) {
    super(identifier, POLICY_TYPE.MinSpend, policyLevel);

    this.limits = [];
  }

  toString() {
    let limitsString = 'No limits';
    if(this.limits && this.limits.length > 0) {
      limitsString = this.limits
        .map(l => Object.assign(new MinSpendPolicyLimit(), l))
        .map(mspl => mspl.toString())
        .join(', ');
    }

    return `${this.identifier}: ${POLICY_TYPE.nameof(this.policyType)} (${limitsString})`;
  }

  isValid() {
    let isValid = !!this.identifier && !!this.identifier.trim();
    if (this.limits && this.limits.length > 0) {
      isValid = isValid && this.limits
        .map(l => Object.assign(new MinSpendPolicyLimit(), l))
        .every(l => l.isValid());
    }
    return isValid;
  }

  static fromJSON(json){
    if(!json) return undefined;

    return Object.assign(new MinSpendPolicy(), json);
  }
}

export class MinSpendPolicyLimit extends PolicyLimitConfiguration {
  constructor(limitType, intAmount, currency) {
    super('MinimumSpendPolicyLimitConfiguration', limitType);

    this.minimumSpendAmount = {
      value: Number.parseInt(intAmount),
      currency: currency
    };
  }

  toString() {
    return `${POLICY_LIMIT_TYPE.nameof(this.limitType)}: ${this.minimumSpendAmount.currency} ${this.minimumSpendAmount.value / 100}`;
  }

  isValid() {
    const amountIsValid =
      this.minimumSpendAmount !== undefined &&
      this.minimumSpendAmount !== null &&
      this.minimumSpendAmount.value >= 0;

    return amountIsValid;
  }

  static fromJSON(json){
    if(!json) return undefined;

    return Object.assign(new MinSpendPolicyLimit(), json);
  }
}


